/*
 * @Author: YuanYuan
 * @Date: 2024-08-28 19:00:40
 * @LastEditTime: 2026-01-29 14:27:52
 * @Description: 全局状态管理模块
 */
import $api from '@/api'
import $const from '@/constants'
import i18n from '@/i18n'

const DefaultSessionScope = {
  isPricing: false,
  isPricingClient: false,
  packageDiscount: 1,
  isCanTransClient: false, // 是否显示选择客户
  isDistributor: false, // 是否显示渠道管理
  mainUser: '', // 当前账号
  parentUser: '', //  主账号
  hasDistributor: false, // 支付页面是否显示代付
  isCanCashPay: false, // 支付页面是否显示现金账户
  inviteCode: '', // 邀请码
  goodsCode: '' // 登录账号默认商品
}

const state = {
  loginNextRoute: '',
  waapDictMap: {},
  isAbroad: true, // 固定值；对应csec2.0 .jsp 中的 isAbroad
  sessionScope: { // 对应csec2.0 .jsp 中的 sessionScope
    ...DefaultSessionScope
  },
  productTypeList: [],
  menuData: [],
  userSwitch: 'false', // 当前是否切换到了子账户上
  menuToggle: false, // 菜单栏是否收起
  permissionCodes: [] // 权限码
}

const getters = {
  menuData: state => state.menuData,
  menuToggle: state => state.menuToggle
}

const mutations = {
  INIT_STATE(state) {
    state.loginNextRoute = ''
    state.userSwitch = 'false'
    state.sessionScope = {
      ...DefaultSessionScope
    }
  },
  SET_LOGIN_NEXT_ROUTE(state, val) {
    state.loginNextRoute = val
  },
  SET_WAAP_DICT_MAP(state, val) {
    state.waapDictMap = val
  },
  SET_PRODUCT_TYPES(state, val) {
    state.productTypeList = val
  },
  SET_MENUS(state, val) {
    const validCodes = [
      ...$const['Common/GoodsCodeOptions'].map(n => `Configurations-${n.value}`),
      'Bills',
      'Distributor'
    ]
    const tempMenu = []
    validCodes.forEach(code => {
      const codeMenu = val.find(n => n.code === code)
      tempMenu.push(codeMenu)
    })
    // 账号信息管理菜单写死，兼容waap的头部菜单
    tempMenu.push({
      code: 'User',
      nameCn: '账号信息管理',
      nameEn: 'My Profile',
      children: [
        { nameCn: '基本信息', nameEn: i18n.t('menu.basicInfo'), url: '/baseInfo' },
        { nameCn: '安全设置', nameEn: i18n.t('menu.securitySetting'), url: '/securitySet' },
        { nameCn: '通知设置', nameEn: i18n.t('menu.noteSet'), url: '/noteSet' }
      ]
    })
    state.menuData = tempMenu
  },
  SET_PERMISSIONS(state, val) {
    state.permissionCodes = val
  },
  SET_SESSION_SCOPE(state, val) {
    state.sessionScope = Object.assign({}, DefaultSessionScope, val)
    state.sessionScope.parentUser = val.parentUser || val.mainUser
  },
  SET_USER_SWITCH(state, val) {
    state.userSwitch = val
  },
  SET_MENU_TOGGLE(state, val) {
    state.menuToggle = val
  }
}

const actions = {
  // 设置 waap 字典数据
  setWaapDict({ commit }) {
    const dictKeys = $const['Common/WaapDictKeys']
    $api['common/waapDict']({
      codeList: dictKeys,
      consoleCode: ''
    }).then(res => {
      if(res?.code === 200) {
        commit('SET_WAAP_DICT_MAP', res?.data || {})
      }
    }).catch(() => {
      const defaultDict = {}
      dictKeys.forEach(key => {
        defaultDict[key] = []
      })
      commit('SET_WAAP_DICT_MAP', defaultDict)
    })
  },
  setProductTypes({ commit }) {
    $api['common/productList']().then(res => {
      if (res?.code === 200 && res?.data?.length) {
        commit('SET_PRODUCT_TYPES', res.data)
      }
    })
  },
  setMenus({ commit }) {
    $api['common/menus']().then(res => {
      if (res?.code === 200) {
        commit('SET_MENUS', res.data.trees)
        const codes = res.data.codes
        commit('SET_PERMISSIONS', [...new  Set(codes)])
      }
    })
  },
  setSessionScope({ commit }) {
    $api['common/attributes']().then(res => {
      if (res?.code === 200) {
        commit('SET_SESSION_SCOPE', res.data)
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
